<ng-container *ngIf="photo$ | async as picture; else elseBlock">
  <app-circle-image [photo]="picture" [width]="width" [text]="text"> </app-circle-image>
</ng-container>

<ng-template #elseBlock>
  <app-circle-image [width]="width" [text]="text" *ngIf="!width || width > 15" [backgroundWhite]="backgroundWhite"> </app-circle-image>
  <i class="fa-fw fas fa-user" *ngIf="width <= 15"></i>
</ng-template>
